import { Component, EventEmitter, OnDestroy, OnInit, Output ,ChangeDetectorRef} from '@angular/core';
import { JobServicesService } from 'src/app/services/job-services.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { EventServicesService } from 'src/app/services/event-services.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppService } from 'src/app/services/app.service';
import { DatePipe } from '@angular/common';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

interface Stage {
  id: string,
  name: string,
  type: string,
  stageId: number,
  isActive: boolean,
  isRenameStage: boolean,
  workflowIds: string,
  actions: Array<any>,
  deletable: boolean,
  scheduleTest?: any;
  _stageId?: any;
  candidate_count?: number;
  is_walk_in?: boolean;
  walk_in_short_code?: string;
  walk_in_key?: string;
}

enum ErrorFields {
  email = 'Invalid Email Id',
  cohortName = 'Invalid Cohort Name',
  jobLocation = 'Invalid Job Location',
  jobRole = 'Invalid Job Role',
  emptyEmail = 'Empty Email Id',
  emptycohortName = 'Empty Cohort Name',
  emptyjobLocation = 'Empty Job Location',
  emptyjobRole = 'Empty Job Role'
}

@Component({
    selector: 'app-workflow',
    templateUrl: './workflow.component.html',
    styleUrls: ['./workflow.component.css'],
    providers: [MessageService, ConfirmationService, DatePipe],
    standalone: false
})
export class WorkflowComponent implements OnInit, OnDestroy {

  @Output() stagesEmitter = new EventEmitter<Array<Stage>>();

  stageTypes: Array<any> = [];
  stages: Array<Stage> = [];
  documentationForms: Array<any> = [];
  feedbackForms: Array<any> = [];
  testForms: Array<any> = [];
  offerForms: Array<any> = [];
  selectedStage: any = [];
  deepLinkStageId: string = '';
  deepLinkStatus: string = '';
  private currentStageSub?: { unsubscribe: () => void };
  applicationTrigger: string = '';
  applicationActions: Array<any> = [];
  testActions: Array<any> = [];
  interviewActions: Array<any> = [];
  screeningActions: Array<any> = [];
  workflowIds: any = [];
  cohortFileSize: any;
  requiredColumns: Array<any> = [];
  cohortFile: Array<any> = [];
  cohortFileCopy: Array<any> = [];
  errorFileData: any;
  errorFile: any;
  templateOptions: Array<any> = [];
  stageActions: any = [];
  selectedMailTemplateId: any;
  selectedMailTemplate: any;
  searchEmail: any;
  emails : any;
  validatedData: any;
  schoolId: any;
  eventStageFormData: any;
  forceRadioRerender: boolean = true;

  selectedType: any = null;
  selectedForm: any = null;
  stageName: string = '';
  isWalkIn: boolean = false;
  regeneratingKeyStageId: string = '';
  copiedWalkInField: string = '';
  showWalkInKey: boolean = false;  // mask the secret key by default
  jobName: string = '';
  eventName: string = '';
  jobId: string = '';
  eventId: string = '';
  stageRename: string = '';
  testId: string = '';
  contestId: string = '';
  cohortDownloadRadio: string = 'generic-template';
  templateValue: Array<any> = [];
  counts: any;
  templateLabel: string = '';
  userPrivileges: Set<string> = new Set();
  searchText: string = '';
  agents: Array<{ label: string, value: string }> = [];
  selectedAgent: any = null;
  agentsLoading: boolean = false;
  searchSubject = new Subject<string>();
  dateFormat: string = '';
  evaluationCriteria: string = '';
  sampleCriteriaExpanded: boolean = false;
  copiedSample: boolean = false;

  readonly SAMPLE_CRITERIA_SECTIONS = [
    'Communication & Confidence — How clearly the candidate explains ideas and answers questions.',
    'Relevant Experience — Past React projects, ownership, and real-world exposure.',
    'React Fundamentals — Understanding of hooks, components, props/state, lifecycle, routing.',
    'Coding & Problem Solving — Ability to solve practical frontend problems and debug issues.',
    'API Integration — Experience working with backend APIs, async handling, and state updates.',
    'Performance Awareness — Basic understanding of optimization, rendering, and scalability.',
    'Clean Code Practices — Reusability, component structure, readability, and maintainability.',
    'Collaboration & Ownership — Teamwork, handling feedback, and contribution in projects.'
  ];

  get SAMPLE_EVALUATION_CRITERIA(): string {
    return this.SAMPLE_CRITERIA_SECTIONS.join('\n\n');
  }

  displayAddStage: boolean = false;
  currentDialogStep: number = 1;
  isLoading: boolean = false;
  isInEvent: boolean = false;
  displayShortlisted: boolean = true;
  displayRuleEngine: boolean = false;
  isTestSelected: boolean = false;
  isFeedbackSelected: boolean = false;
  displayCohort: boolean = false;
  saveBtnLoading: boolean = false;
  finalStage : boolean = false;
  confirmBtnLoading : boolean = false;
  cohortUploaded: boolean = false;
  uploadingFile: boolean = false;
  cohortError: boolean = false;
  clicked: boolean = false;
  moveStep : boolean = false;
  countDiv : boolean = true;
  emailsCleared : boolean = false;
  showBulkCohort: boolean = false;
  _stageId: number = 0;
  privilege: any;
  errorPlaceholder: any = [];
  isSaveClicked = false;
  isTemplateValidated: boolean = false;
  
  // Drag and drop state
  isDragMode: boolean = false;
  originalStagesOrder: Array<Stage> = [];
  isSavingReorder: boolean = false;


  uploadCohort: FormGroup = new FormGroup({
    Bucket_name: new FormControl(''),
    file_name: new FormControl('', Validators.required),
    actionId: new FormControl(''),
    eventId: new FormControl(''),
    stageId : new FormControl('')
  })

  constructor(
    private jobService: JobServicesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private emailServices: EmailServicesService,
    private globalService: GlobalServicesService,
    private fileUploadService: FileUploadService,
    private eventServices: EventServicesService,
    private router: Router,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      const trimmed = value.trim();
      if (trimmed.length === 0) {
        this.searchEmail = [];
        this.emailsCleared = true;
      } else if (trimmed.length > 2) {
        this.searchEmail = trimmed.split(/\s+/);
        this.emailsCleared = false;
      }
    });
    // this.stageTypes = ['Assessment', 'Online Interview', 'Documentation', 'Onboarding', 'Others', 'Offer']

    this.requiredColumns = [
      { index: 1, field: 'email', header: 'email' },
      { index: 2, field: 'cohortName', header: 'cohortName' },
      { index: 3, field: 'jobRole', header: 'jobRole' },
      { index: 4, field: 'jobLocation', header: 'jobLocation' }
      ]

      this.appService.makeFlexBasedUi.next(true);
  }

  ngOnDestroy(): void {
    this.appService.makeFlexBasedUi.next(false);
    this.currentStageSub?.unsubscribe();
  }

  async ngOnInit() {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.jobName = window.localStorage.getItem("selectedJobName") || '';
    this.eventName = window.localStorage.getItem("selectedEventName") || '';
    this.activatedRoute.paramMap.subscribe(params => {
      this.jobId = params.get('eventId') || '';
    });    this.activatedRoute.paramMap.subscribe(params => {
      this.eventId = params.get('eventId') || '';
    });    this.isInEvent = this.jobId === this.eventId;
    // Capture the deep-link status synchronously (before getStages()'s async load and
    // before any prior instance re-navigates and strips it from the URL).
    const deepLink = this.activatedRoute.snapshot.queryParamMap;
    this.deepLinkStageId = deepLink.get('stageId') || '';
    this.deepLinkStatus = deepLink.get('status') || '';
    this.getStages();
    // this.formData();
    this.schoolId = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.school_code : '';
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
  }
  async getEmailTemplates(stageType?: string) {
    try {
      const templateType = stageType || 'Others';
      this.emailServices.getTemplatesFastApi('', templateType).subscribe({
        next: (response) => {
          if (response.status === 200) {
            let templateList = response.body.email_templates ? response.body.email_templates : [];
            this.templateOptions = templateList.map((item: any) => ({
              id: item.id,
              isEditable: item.is_editable,
              name: item.name,
            }));
          }
        },
        error: (_err) => {
        }
      });
    } catch (error) {
      console.error('Error fetching email templates:', error);
    }
  }
  reorderStages(stagesList: string[]): string[] {
    const stageOrder: {[key: string]: number} = {
      'Documentation': 1,
      'Assessment': 2,
      'Online Interview': 3,
      'Offline Interview': 4,
      'Offer': 5,
      'Onboarding': 6,
      'Others': 7,
      'Other': 7
    };
    
    return [...stagesList].sort((a, b) => {
      const orderA = stageOrder[a] || 99;
      const orderB = stageOrder[b] || 99;
      return orderA - orderB;
    });
  }
  async formData() {
    this.isLoading = true;
    try {
      const response = await firstValueFrom(this.jobService.getEventStageFormDataFastApi(this.eventId));

      if (response?.status === 200) {
        const mapForms = (forms: any[]) => forms.map((element: any) => ({
          label: element.name,
          value: element.uuid,
      }));
      const mapContests = (contests: any[]) => contests.map((element: any) => ({
          label: element.name,
          value: element.uuid,
          test_start_date: element.test_start_date
      }));
      this.stageTypes = this.reorderStages(response.body.types);
      this.documentationForms = mapForms(response.body.documentation_forms);
      this.feedbackForms = mapForms(response.body.feedback_forms);
      this.offerForms = mapForms(response.body.offer_forms);
      this.testForms = mapContests(response.body.contests);
      this.eventServices.setForms(this.documentationForms, this.feedbackForms, this.testForms, this.offerForms);
      this.eventStageFormData = {
        documentationForms: this.documentationForms,
        feedbackForms: this.feedbackForms,
        offerForms: this.offerForms,
        testForms: this.testForms
      };
      }
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error fetching stages' });
    } finally {
      this.isLoading = false;
    }
  }
  onSearchInputChange() {
    this.searchSubject.next(this.searchText);
  }
  async getStages() {
    this.isLoading = true;
    
    try {
        const response = await firstValueFrom(this.jobService.getAllStagesFastApi(this.jobId));
        
        if (response?.status === 200 && response.body?.stages?.length) {
            this.stageActions = response.body.stage_actions;
            this.stages = response.body?.stages || [];
            
            this.stages.forEach((stage: any) => {
                stage.id = stage.uuid;
                stage.name = stage.name;
                stage.type = stage.type;
                stage.stageId = stage.uuid;
                stage.isActive = false;
                stage.isRenameStage = false;
                stage.actions = this.stageActions[stage.type];
                stage.deletable = true;                
                if (stage.type === 'Assessment') {
                    stage.isEditable = stage.is_contest_editable !== false;
                } else {
                    stage.isEditable = stage.is_form_editable !== false;
                }                
                if (stage.isEditable === undefined) {
                    stage.isEditable = true;
                }
            });
            
            // this.stages = this.stages.filter((stage: any) => this.privilege.viewManageEventsStages.includes(stage.type));
            
            if (this.stages.length > 0) {
                this.stages[0].isActive = true;
            }
            
            this._stageId = this.stages.length;
            
            let stageCount = 0;
            this.stages.forEach((stage: any) => {
                stageCount += 1;
                stage._stageId = stageCount;
            });
            
            this.openCurrentStage();
            this.stagesEmitter.emit(this.stages);
        }
      } catch (error) {
          console.error('Error fetching stages:', error);
      } finally {
          this.isLoading = false;
      }
  }
  onCategoryChange(): void {    
    this.stageName = '';
    this.selectedForm = '';
    this.selectedAgent = null;
    this.errorPlaceholder = [];
    this.selectedMailTemplate = '';
    this.selectedMailTemplateId = '';
    this.evaluationCriteria = '';
    this.isTemplateValidated = this.selectedType === 'Onboarding' || this.selectedType === 'Others';
    if (this.selectedType) {
      this.getEmailTemplates(this.selectedType);
    }
  }

  openCurrentStage = () => {
    this.currentStageSub?.unsubscribe();
    this.currentStageSub = this.activatedRoute.queryParamMap.subscribe((param) => {
      const stageId = param.get('stageId') || '';
      const tabView = param.get('view') || '';
      if (stageId.length) this.openStage(stageId);
      else if(tabView == 'workflow') this.openStage(this.stages[0].id)
    })
  }
  public async onClickAddStage() {
    this.displayAddStage = true;
    this.isLoading = true;
    if (this.selectedStage) {
      this.selectedStage.isActive = false;
    }
    await this.formData();
    this.isLoading = false;
  }
  async onRulesTabClick() {
    this.displayShortlisted = false;
    this.displayRuleEngine = true;    
    if ((this.userPrivileges.has('event_stage.update') || this.userPrivileges.has('event_stage.create')) && !this.eventStageFormData) {
      await this.formData();
    }
  }  
  async addStage(payload: any) {
    this.isLoading = true;
    try {
      const response = await firstValueFrom(this.jobService.addStageFastApi(payload,this.eventId));

      if (response.status === 201) {
        await this.getStages();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.body.detail });

        this.displayAddStage = false;
        this.currentDialogStep = 1;
        this.resetFormFields();
        
        let hasActiveStage = this.stages.some(stage => stage.isActive);
        if (!hasActiveStage && this.stages.length > 0) {
          this.stages[0].isActive = true;
          this.selectedStage = this.stages[0];
        }
        this.searchEmail = '';
      }
    } catch (error) {
      this.displayAddStage = false;
      this.currentDialogStep = 1;
      this.resetFormFields();
    } finally {
      this.isLoading = false;
      this.isSaveClicked = false;
    }
  }

  validateTemplate() {
    const data = this.selectedMailTemplate;
    const template: string = data.templateContent ?? "";
    this.errorPlaceholder = [];
    const placeholdersByType: Record<string, Record<string, string>> = {
      "Assessment": {
        "User": "${full_name}",
        "Test_Link": "${test_link}"
      },
      "Online Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_link": "${interview_link}"
      },
      "Offline Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_venue": "${interview_venue}"
      },
      "AI Interview": {
        "User": "${full_name}",
        "interview_start_date": "${interview_start_time}",
        "interview_end_date": "${interview_end_time}",
        "interview_link": "${interview_link}"
      },
      "Documentation": {
        "User": "${full_name}",
        "document_link": "${document_link}"
      },
      "Offer": {
        "User": "${full_name}",
        "offer_link": "${offer_link}",
      },
    }

    const requiredPlaceholders = placeholdersByType[this.selectedType]
    if (requiredPlaceholders) {
      for (const placeholder in requiredPlaceholders) {
        if (!template.includes(requiredPlaceholders[placeholder])) {
          this.errorPlaceholder.push(placeholder)
        }
      }
    }
    this.isTemplateValidated = this.errorPlaceholder.length === 0;
  }

  createStage = () => {
    if (this.isSaveClicked) {
      return;
    }
    if (!this.stageName) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter a stage name!' });
      return;
    }
    if (this.selectedType === 'Assessment' && !this.selectedForm) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a test form!' });
      return;
    }
    if ((this.selectedType === 'Documentation' || this.selectedType === 'Online Interview' || this.selectedType === 'Offer' || this.selectedType === 'Offline Interview') && !this.selectedForm) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a form!' });
      return;
    }
    if ((this.selectedType === 'Documentation' || this.selectedType === 'Assessment' || this.selectedType === 'Online Interview' || this.selectedType === 'Offer' || this.selectedType === 'Offline Interview' || this.selectedType === 'AI Interview') && !this.selectedMailTemplateId && !(this.selectedType === 'Assessment' && this.isWalkIn)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a mail template!' });
      return;
    }
    if (this.selectedType === 'AI Interview' && !this.selectedAgent) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select an agent!' });
      return;
    }
    if (this.selectedType === 'AI Interview' && (!this.evaluationCriteria || this.evaluationCriteria.trim().length === 0)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter evaluation criteria!' });
      return;
    }
    if ((this.selectedType === 'Online Interview' || this.selectedType === 'Offline Interview') && this.evaluationCriteria && this.evaluationCriteria.length > 1000) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Evaluation criteria cannot exceed 1000 characters!' });
      return;
    }
    if (this.selectedType === 'AI Interview' && this.evaluationCriteria && this.evaluationCriteria.length > 1000) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Evaluation criteria cannot exceed 1000 characters!' });
      return;
    }
    this.isSaveClicked = true;
    this.isLoading = true;
    let payload: any = {
      event_uuid: this.jobId || this.eventId,
      name: this.stageName,
      type: this.selectedType,
      contest_uuid: this.selectedType === 'Assessment' ? this.selectedForm : null,
      email_template_id: (this.selectedType === 'Assessment' && this.isWalkIn)
        ? null
        : ((this.selectedType === 'Documentation' || this.selectedType === 'Assessment' || this.selectedType === 'Online Interview' || this.selectedType === 'Offer' || this.selectedType === 'Offline Interview' || this.selectedType === 'AI Interview') ? this.selectedMailTemplateId?.id : null),
      is_walk_in: this.selectedType === 'Assessment' ? this.isWalkIn : false
    };
    if (this.selectedType === 'AI Interview') {
      if (this.selectedForm) {
        payload.form_uuid = this.selectedForm;
      }
    } else if (this.selectedType === 'Documentation' || this.selectedType === 'Online Interview' || this.selectedType === 'Offer' || this.selectedType === 'Offline Interview') {
      payload.form_uuid = this.selectedForm;
    }

    if (this.selectedType === 'AI Interview' && this.selectedAgent) {
      payload.ai_agent = this.selectedAgent;
    }
    
    if ((this.selectedType === 'AI Interview' || this.selectedType === 'Online Interview' || this.selectedType === 'Offline Interview') && this.evaluationCriteria && this.evaluationCriteria.trim().length > 0) {
      payload.evaluation_criteria = this.evaluationCriteria.trim();
    }

    this.addStage(payload);
  }

  async duplicateStage(stage: any, overlayElement: any) {
    if (stage.type === 'Registration') {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Registration stage cannot be duplicated!' });
      return;
    }
    let payload: any = {
      event_uuid: this.jobId || this.eventId,
      name: `${stage.name} copy`,
      type: stage.type,
      contest_uuid: stage.type === 'Assessment' ? stage.contest?.uuid : null,
      form_uuid: (stage.type === 'Documentation' || stage.type === 'Online Interview' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'AI Interview') ? (stage.form?.uuid || null) : null,
      email_template_id: (stage.type === 'Documentation' || stage.type === 'Online Interview' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'Assessment' || stage.type === 'AI Interview') ? stage.email_template?.id : null,
      is_walk_in: stage.type === 'Assessment' ? !!stage.is_walk_in : false
    };
    if (stage.type === 'AI Interview' && stage.ai_agent_uuid) {
      payload.ai_agent = stage.ai_agent_uuid;
    }
    if ((stage.type === 'AI Interview' || stage.type === 'Online Interview' || stage.type === 'Offline Interview') && stage.evaluation_criteria) {
      payload.evaluation_criteria = stage.evaluation_criteria;
    }
    overlayElement.hide();
    await this.addStage(payload);
    this.stages.forEach((stage: any) => (stage.isActive = false));
    if (this.stages.length > 0) {
      this.stages[this.stages.length - 1].isActive = true;
    }
  }

  renameStage = async (stage: any) => {
    const payload: any = {
      event_uuid: this.jobId,
      name: this.stageRename,
      type: stage.type,
      contest_uuid: stage.type === 'Assessment' ? stage.contest?.uuid : null,
      form_uuid: (stage.type === 'Documentation' || stage.type === 'Online Interview' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'AI Interview') ? (stage.form?.uuid || null) : null,
      email_template_id: (stage.type === 'Assessment' || stage.type === 'Online Interview' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'AI Interview') ? stage.email_template?.id : null,
      is_walk_in: stage.type === 'Assessment' ? !!stage.is_walk_in : false,
    };

    if (stage.type === 'AI Interview' && stage.ai_agent_uuid) {
      payload.ai_agent = stage.ai_agent_uuid;
    }
    
    if ((stage.type === 'AI Interview' || stage.type === 'Online Interview' || stage.type === 'Offline Interview') && stage.evaluation_criteria) {
      payload.evaluation_criteria = stage.evaluation_criteria;
    }

    if (this.stageRename.length && this.stageRename !== stage.name) {
      this.isLoading = true;

      try {
        const response = await firstValueFrom(this.jobService.updateStageFastApi(stage.id, payload));
        if (response.status === 200) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.body.detail });
          this.stageRename = '';
          await this.getStages();
        }
      } catch (error) {
        console.error('Error updating stage:', error);
      } finally {
        this.isLoading = false;
      }
    } else {
      stage.isRenameStage = false;
    }
  }

deleteStage = (id: string, event?: any) => {
  this.confirmationService.confirm({
    target: event?.target,
    message: 'Are you sure that you want to proceed?',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      this.isLoading = true;
      
      this.jobService.deleteStageFastApi(id,this.eventId).subscribe({
        next: (response) => {
          if(response.status === 200){
            this.stages = this.stages.filter((val: any) => val.id !== id);
            
            if (this.stages.length > 0) {
              this.stages[0].isActive = true;
            }
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.body.detail });
            this.isLoading = false;
          }
        },
        error: (_err) => {
          this.isLoading = false;
        }
      });
    },
    reject: () => {
      // User rejected the deletion
    }
  });
}


  resetFormFields = () => {
    this.selectedType = '';
    this.stageName = '';
    this.selectedForm = '';
    this.selectedMailTemplateId = '';
    this.selectedMailTemplate = '';
    this.errorPlaceholder = [];
    this.evaluationCriteria = '';
    this.selectedAgent = null;
    this.isTemplateValidated = false;
    this.sampleCriteriaExpanded = false;
    this.copiedSample = false;
    this.isWalkIn = false;
  }

  // ---- Walk-in mode (Assessment stages) ----

  // Dotted mask for the secret key while it is hidden.
  maskedKey(key: string | undefined): string {
    return key ? '•'.repeat(key.length) : '';
  }

  getWalkInUrl(stage: any): string {
    return stage?.walk_in_short_code
      ? `${window.location.origin}/assessment/${stage.walk_in_short_code}`
      : '';
  }

  copyWalkInValue(value: string | undefined, field: string): void {
    if (!value) return;
    navigator.clipboard?.writeText(value).then(() => {
      this.copiedWalkInField = field;
      setTimeout(() => {
        if (this.copiedWalkInField === field) this.copiedWalkInField = '';
      }, 2000);
    });
  }

  regenerateWalkInKey(stage: any): void {
    if (!stage?.id || this.regeneratingKeyStageId) return;
    this.regeneratingKeyStageId = stage.id;
    this.jobService.regenerateWalkInKeyFastApi(this.eventId, stage.id).subscribe({
      next: (res: any) => {
        const newKey = res?.body?.result?.walk_in_key;
        if (newKey) {
          stage.walk_in_key = newKey;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Access key regenerated successfully!' });
        }
        this.regeneratingKeyStageId = '';
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to regenerate access key. Please try again.' });
        this.regeneratingKeyStageId = '';
      }
    });
  }

  toggleSampleCriteria(): void {
    this.sampleCriteriaExpanded = !this.sampleCriteriaExpanded;
  }

  copySampleCriteria(event: Event): void {
    event.stopPropagation();
    navigator.clipboard.writeText(this.SAMPLE_EVALUATION_CRITERIA).then(() => {
      this.copiedSample = true;
      setTimeout(() => { this.copiedSample = false; }, 2000);
    }).catch(() => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to copy to clipboard' });
    });
  }

  closeAddStage = () => {
    this.resetFormFields();
    this.displayAddStage = false;
    this.currentDialogStep = 1;    
    if (this.stages.length > 0) {
      let hasActiveStage = this.stages.some(stage => stage.isActive);
      if (!hasActiveStage) {
        this.stages[0].isActive = true;
        this.selectedStage = this.stages[0];
      }
      this.searchEmail = '';
    }
  }

  goToStep = (step: number) => {
    if (step === 1 && this.currentDialogStep === 2) {
      this.forceRadioRerender = false;
      
      setTimeout(() => {
        this.forceRadioRerender = true;
        this.currentDialogStep = step;
        this.cdr.detectChanges();
      }, 0);
    } else {
      this.currentDialogStep = step;
    }
    
    if (step === 2) {
      this.stageName = '';
      this.selectedForm = '';
      this.selectedMailTemplateId = '';
      this.selectedMailTemplate = '';
      this.errorPlaceholder = [];
      this.evaluationCriteria = '';
      this.isTemplateValidated = this.selectedType === 'Onboarding' || this.selectedType === 'Others';
      
      if (this.selectedType === 'AI Interview') {
        this.loadAgents();
      }
    }
  }

  openStage = (id: string) => {
    if (this.isInEvent) this.router.navigate(['events/', this.eventId], { queryParams: { view: 'workflow', stageId: id } });
    else this.router.navigate(['jobs/', this.jobId], { queryParams: { view: 'workflow', stageId: id } });

    this.stages.forEach((stage: any) => {
      if (stage.id === id) {
        stage.isActive = true;
        this.selectedStage = stage
      } else {
        stage.isActive = false;
        stage.isRenameStage = false;
      }
    })
    this.searchEmail = '';
    this.displayShortlisted = true;
    this.displayRuleEngine = false;
    
    if (this.displayAddStage) {
      this.displayAddStage = false;
      this.currentDialogStep = 1;
      this.resetFormFields();
    }
  }

  addRule = (stage: any) => {
    stage.workflowIds.push('-');
  }

  removeRule = (event: any, stage: any) => {
    stage.workflowIds = stage.workflowIds.filter((id: string) => id !== event);
    if (stage.workflowIds.length === 0) this.addRule(stage);
  }

  updateRule = (event: any, stage: any) => {
    stage.workflowIds.splice(stage.workflowIds.indexOf('-'), 1, event);
  }

  checkTestSelected = (event: boolean) => {
    this.isTestSelected = event;
  }

  checkFeedbackSelected = (event: boolean) => {
    this.isFeedbackSelected = event;
  }

  searchEmailCandidate = (event: any) => {
    let data = event.target.value;
    this.searchEmail = data.trim().split(/\s+/);
  }

  bulkCohort(){
    this.finalStage = false;
    this.displayCohort = true; 
    if( Array.isArray(this.emails) && this.emails.length){
      this.cohortDownloadRadio = 'selected-candidates'
    } else {
      this.cohortDownloadRadio = 'generic-template';
    }
  }

  back(){
    this.finalStage = false;
    this.templateValue = [];
    this.templateLabel = '';
    this.clicked = false;
  }
  emailList(event: any){
      this.emails = event;
  }
  locationCheck(data: any): boolean {
    let foundInvalidLocation = true;
  
    this.errorFileData.forEach((item: any) => {
      if (item?.invalidLocation && item?.invalidLocation[data] == false) {
        foundInvalidLocation = false;
      }
    });
  
    return foundInvalidLocation;
  }

  errorCheck(){
    let error: any = [];
    let error2: string[] = [];
    this.errorFileData.forEach((element:any) => {
      let errorFields = element.remarks.split(',');
      for(let i = 0; i < errorFields.length; i++){
        if(errorFields[i] == ErrorFields.email || errorFields[i] == ErrorFields.emptyEmail){
          error2.push('email');
        }else if(errorFields[i] == ErrorFields.cohortName || errorFields[i] == ErrorFields.emptycohortName){
          error2.push('cohortName');
        }else if(errorFields[i] == ErrorFields.jobLocation || errorFields[i] == ErrorFields.emptyjobLocation){
          error2.push('jobLocation');
        }else if(errorFields[i] == ErrorFields.jobRole || errorFields[i] == ErrorFields.emptyjobRole){
          error2.push('jobRole');
        }else if(errorFields[i] == 'Candidate is not in the stage'){
          error2.push('Candidate is not in the stage');
        }
      }
      error.push(error2);
      error2 = [];                     
    });
    for(let i = 0; i < this.errorFileData.length; i++){
      this.errorFileData[i].remarks = error[i];
    }
}

  errorReportDownload(){
    window.open(this.errorFile,'_blank')
  }

  cohortClosed(){
    this.cohortDownloadRadio = 'generic';
    this.clicked = false;
    this.cohortUploaded = false;
    this.cohortError = false;
    this.uploadingFile = false;
    this.errorFile = [];
    this.errorFileData = [];
    this.cohortFile = [];
    this.cohortFileCopy = [];

  }
  
  onRemoveExcel(){
    this.cohortUploaded = false;
    this.cohortError = false;
    this.countDiv = true;
    this.counts = 0;
    this.cohortFile = [];
    this.cohortFileCopy = [];
    this.errorFile = [];
    this.errorFileData = [];
  }
  templateChange(event: any){
    this.templateLabel = event.value.label;
    this.templateValue = event.value.value;
  }

  candidateCount(event: any)
  {
    this.showBulkCohort = event > 0 ? true : false;
  }
  async getSelectedMailTemplate(event: any){
    this.isTemplateValidated = false;
    await this.getSpecificTemplateData(event);
    this.validateTemplate()
  }
  async getSpecificTemplateData(template: any,): Promise<void> {
    if (template.id) {
      return new Promise((resolve, reject) => {
        this.emailServices.getSpecificTemplateFastApi(template.id).subscribe({
          next: (response) => {
            if (response.status === 200) {
              this.selectedMailTemplate ={
                templateContent: response.body.body,
                templateTitle: response.body.name,
              };
              resolve();
            }
          },
          error: (err) => {
            reject(new Error('Error fetching specific template: ' + err));
          }
        });
      });
    }
  }
  async getEventStages(event: any){
    if(event){
      await this.getStages();
    }
  }

  formatTestStartDate(dateString: string): string {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const format = this.dateFormat || 'dd-MM-yyyy';
      return this.datePipe.transform(date, format) || '';
    } catch (error) {
      return '';
    }
  }

  loadAgents() {
    if (this.agents.length > 0 || this.agentsLoading) {
      return; // Already loaded or loading
    }
    this.agentsLoading = true;
    this.eventServices.getAgentsFastApi().subscribe({
      next: (response) => {
        if (response.status === 200 && response.body?.result) {
          this.agents = response.body.result.map((agent: any) => ({
            label: agent.name,
            value: agent.id
          }));
        }
        this.agentsLoading = false;
      },
      error: (err) => {
        console.error('Error loading agents:', err);
        this.agentsLoading = false;
        
        let errorMessage = 'Something went wrong.';
        if (err.error) {
          const errorResponse = err.error;
          if (Array.isArray(errorResponse.detail)) {
            errorMessage = errorResponse.detail[0]?.msg || errorResponse.detail[0]?.ctx?.error || 'Something went wrong.';
          } else if (typeof errorResponse.detail === 'string') {
            errorMessage = errorResponse.detail;
          }
        }
        
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: errorMessage });
      }
    });
  }

  getStageTypeClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      'Assessment': 'tag-test',
      'Online Interview': 'tag-interview',
      'Offline Interview': 'tag-offline-interview',
      'Documentation': 'tag-screening',
      'Offer': 'tag-offer',
      'Onboarding': 'tag-onboarding',
      'Registration': 'tag-eligibility',
      'AI Interview': 'tag-ai-interview'
    };
    return typeClassMap[type] || 'tag-default';
  }

  // Check if stage can be dragged (Registration stage cannot be dragged)
  canDragStage(stage: Stage): boolean {
    return stage.type !== 'Registration';
  }

  // Enable drag mode
  enableDragMode(): void {
    if (!this.isDragMode) {
      this.isDragMode = true;
      this.originalStagesOrder = JSON.parse(JSON.stringify(this.stages));
      this.cdr.detectChanges();
    }
  }

  // Cancel drag mode and revert to original order
  cancelDragMode(): void {
    this.isDragMode = false;
    this.stages = JSON.parse(JSON.stringify(this.originalStagesOrder));
    this.originalStagesOrder = [];
    this.cdr.detectChanges();
  }

  // Handle drag drop event
  onStageDrop(event: CdkDragDrop<Stage[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    let newIndex = event.currentIndex;
    if (newIndex === 0) {
      newIndex = 1;
    }

    if (!this.isDragMode) {
      this.enableDragMode();
    }

    moveItemInArray(this.stages, event.previousIndex, newIndex);
    this.cdr.detectChanges();
  }
  async saveStageOrder(): Promise<void> {
    if (this.isSavingReorder) return;
    
    this.isSavingReorder = true;
    const stageUuids = this.stages.map(stage => stage.id);
    
    try {
      const response = await firstValueFrom(
        this.jobService.reorderStagesFastApi(this.eventId || this.jobId, stageUuids)
      );
      
      if (response?.status === 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Stages reordered successfully'
        });
        this.isDragMode = false;
        this.originalStagesOrder = [];
        // Refresh stages to get updated order
        await this.getStages();
      }
    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.error?.detail || 'Failed to reorder stages'
      });
      // Revert to original order on error
      this.cancelDragMode();
    } finally {
      this.isSavingReorder = false;
    }
  }
}
